import { useEffect, useRef } from 'react';
import { calibrationConstants } from '../../../../helpers/calibration-constants';
import { useParticipantTracks, useAttachTrack } from '../../../../helpers/video/useParticipantTracks';
import styled from '@emotion/styled';

const StyledVideo = styled.video`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: ${(props) => (props.disableBorderRadius ? 0 : calibrationConstants.VIDEO_BORDER_RADIUS)}px;
  object-fit: cover;
`;

// Renders a (remote) participant's current video + audio track.
const MobileVideo = ({ participant, parentVideoRef, disableBorderRadius }) => {
  const { videoTrack, audioTrack } = useParticipantTracks(participant);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useAttachTrack(videoTrack, videoRef);
  useAttachTrack(audioTrack, audioRef);

  useEffect(() => {
    if (videoRef.current && parentVideoRef && videoRef.current !== parentVideoRef.current) {
      parentVideoRef.current = videoRef.current;
    }
  });

  return (
    <>
      <audio ref={audioRef} autoPlay />
      <StyledVideo ref={videoRef} autoPlay playsInline muted id={participant.sid} disableBorderRadius={disableBorderRadius} />
    </>
  );
};

export default MobileVideo;
